import { View, Portal, styled, Text, h3, Button, fromTheme } from 'lib_ui-primitives';

export const ConfigurationPortal = styled(Portal).attrs({ name: 'configuration-portal' })`
    flex-direction: column;
`;

export const ConfigurationPortalContainer = styled(View).attrs({ name: 'configuration-portal-container' })`
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
`;
ConfigurationPortalContainer.displayName = 'ConfigurationPortalContainer';

export const Title = styled(h3)`
    margin-left: ${({ theme }) => theme.viewMarginMore}px;
    margin-right: ${({ theme }) => theme.viewMarginMore}px;
`;

export const scrollContainer = styled(View).attrs({ name: 'scroll-container' })`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    width: 100%;
    padding: ${fromTheme('modal', 'columnCustomization', 'padding')};
`;

export const OrderableList = styled(View).attrs({ name: 'orderable-list' })`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 0;
`;
OrderableList.displayName = 'OrderableList';

export const Draggable = styled(View).attrs({ name: 'draggable' })`
    opacity: ${({ isDragging }) => (isDragging ? 0.2 : 1)};
    flex-direction: row;
    flex-grow: 1;
    align-items: center;
    border-top: ${({ isOver }) => (isOver ? 'solid' : 'none')} 4px;
`;
Draggable.displayName = 'Draggable';

export const Label = styled(Text)`
    padding-left: ${fromTheme('buttonPadding')};
    flex-grow: 1;
    min-width: 200px;
    color: ${({ color }) => color};
`;

// reuses the padding from card.footer for consistency
export const ButtonBar = styled(View).attrs({ name: 'button-bar' })`
    display: flex;
    flex-direction: row;
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    justify-content: flex-end;
    padding: ${fromTheme('card', 'footer', 'padding')};
`;

export const DialogButton = styled(Button).attrs({ name: 'dialog-button' })`
    flex-grow: 1;
    width: auto;
    min-width: ${fromTheme('modal', 'button', 'minWidth')};
    max-width: ${fromTheme('modal', 'button', 'maxWidth')};
    justify-content: center;
`;

export const Badge = styled(View).attrs({ name: 'badge' })``;
Badge.displayName = 'Badge';
